import React, { useState } from 'react';

export default function VancoGFREstimator() {
  const [doseTime, setDoseTime] = useState('');
  const [c1Time, setC1Time] = useState('');
  const [c1Value, setC1Value] = useState('');
  const [c2Time, setC2Time] = useState('');
  const [c2Value, setC2Value] = useState('');
  const [weight, setWeight] = useState('');
  const [results, setResults] = useState(null);

  const calculateGFR = () => {
    try {
      const doseDateTime = new Date(doseTime);
      const c1DateTime = new Date(c1Time);
      const c2DateTime = new Date(c2Time);

      const t1 = (c1DateTime - doseDateTime) / (1000 * 3600);
      const t2 = (c2DateTime - doseDateTime) / (1000 * 3600);

      if (t1 === t2) {
        alert('The two levels cannot be at the same time.');
        return;
      }
      if (c1Value <= 0 || c2Value <= 0) {
        alert('Vancomycin levels must be positive.');
        return;
      }

      const ke = Math.log(c1Value / c2Value) / (t1 - t2);
      const vd = 0.7 * weight; // L
      const clVanco = ke * vd; // L/hr
      const gfr = (clVanco * 1000) / 60; // mL/min

      setResults({ ke, clVanco, gfr });
    } catch (err) {
      alert('Error in calculation: ' + err.message);
    }
  };

  const sectionStyle = {
    marginBottom: '1.5rem',
    padding: '1rem',
    border: '2px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 'bold',
    fontSize: '0.95rem',
    color: '#333',
    padding: '0.25rem 0',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    paddingLeft: '0.5rem'
  };

  const inputStyle = {
    width: '100%',
    marginBottom: '1rem',
    padding: '0.5rem',
    border: '1px solid #ccc',
    borderRadius: '4px'
  };

  return (
    <div style={{ maxWidth: '550px', margin: 'auto', padding: '1rem', fontFamily: 'sans-serif', backgroundColor: '#f9f9f9' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Vancomycin-based GFR Estimator</h2>

      <div style={sectionStyle}>
        <h4>Vancomycin Dose</h4>
        <label style={labelStyle}>Time of last dose:</label>
        <input type="datetime-local" value={doseTime} onChange={(e) => setDoseTime(e.target.value)} style={inputStyle} />
      </div>

      <div style={sectionStyle}>
        <h4>First Level (C1)</h4>
        <label style={labelStyle}>C1 time:</label>
        <input type="datetime-local" value={c1Time} onChange={(e) => setC1Time(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>C1 value (mg/L):</label>
        <input type="number" step="0.01" value={c1Value} onChange={(e) => setC1Value(e.target.value)} style={inputStyle} />
      </div>

      <div style={sectionStyle}>
        <h4>Second Level (C2)</h4>
        <label style={labelStyle}>C2 time:</label>
        <input type="datetime-local" value={c2Time} onChange={(e) => setC2Time(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>C2 value (mg/L):</label>
        <input type="number" step="0.01" value={c2Value} onChange={(e) => setC2Value(e.target.value)} style={inputStyle} />
      </div>

      <div style={sectionStyle}>
        <h4>Patient Info</h4>
        <label style={labelStyle}>Weight (kg):</label>
        <input type="number" step="0.1" value={weight} onChange={(e) => setWeight(e.target.value)} style={inputStyle} />
      </div>

      <button onClick={calculateGFR} style={{ width: '100%', padding: '0.75rem', background: '#005A9C', color: 'white', border: 'none', borderRadius: '6px', fontSize: '1rem', cursor: 'pointer' }}>Calculate GFR</button>

      {results && (
        <div style={{ marginTop: '2rem', padding: '1rem', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <h3>Results</h3>
          <p><strong>Elimination rate constant (Ke):</strong> {results.ke.toFixed(4)} hr⁻¹</p>
          <p><strong>Vancomycin clearance:</strong> {results.clVanco.toFixed(2)} L/hr</p>
          <p><strong>Estimated GFR:</strong> {results.gfr.toFixed(1)} mL/min</p>
          <small>Assumes stable renal function, post-distribution levels, and minimal non-renal clearance.</small>
        </div>
      )}
    </div>
  );
}
